import { QueryFunction, useQuery } from '@tanstack/react-query';

import { useFetchWithAuth } from '../useFetchWithAuth';

// Deprecated: gebruik de clientStore voor stamgegevens zoals materieeltypen en dienstregelpunten
//
export const useGetAlleMaterieeltypenApi = (rollingStockTypeSelected: boolean) => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<string[]> = async () => {
    const response = await fetchWithAuth('/stamgegevens/materieeltypen');
    if (response.status > 499) {
      throw new Error(`Applicatiefout ${response.status}: ${response.statusText}`);
    } else if (!response.ok) {
      return [];
    } else {
      return response.json();
    }
  };

  return useQuery({
    queryKey: ['useGetAlleMaterieeltypenApi'],
    queryFn: fetcher,
    enabled: rollingStockTypeSelected,
  });
};
